import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes, { InferProps } from 'prop-types';
import LinkAndAnchor from '../LinkAndAnchor';
import getStandBreadcrumbs from '../Stand/getBreadcrumbs';
import getMarketBreadcrumbs from '../Market/getBreadcrumbs';
import getMarketsBreadcrumbs from '../Markets/getBreadcrumbs';
import messages from '../../lib/messages';

const breadCrumbsPropertyTypes = {
  marketName: PropTypes.string,
  standName: PropTypes.string,
  standId: PropTypes.number,
  marketId: PropTypes.number,
};

type BreadCrumbsProperties = InferProps<typeof breadCrumbsPropertyTypes>;

const BreadCrumbs = ({
  marketName, marketId, standName, standId,
}: BreadCrumbsProperties) => {
  const intl = useIntl();

  if (marketId && standId) {
    return (
      [
        ...getStandBreadcrumbs({
          marketName, marketId, standName, standId,
        }),
        <LinkAndAnchor
          route="products"
          params={{
            marketId: marketId.toString(),
            standId: standId.toString(),
          }}
        >
          {intl.formatMessage(messages.products)}
        </LinkAndAnchor>,
      ]
    );
  }

  if (marketId) {
    return (
      [
        ...getMarketBreadcrumbs({
          marketName, marketId,
        }),
        <LinkAndAnchor
          route="products"
          params={{ marketId: marketId.toString() }}
        >
          {intl.formatMessage(messages.products)}
        </LinkAndAnchor>,
      ]
    );
  }

  return (
    [
      ...getMarketsBreadcrumbs(),
      <LinkAndAnchor
        route="products"
      >
        {intl.formatMessage(messages.products)}
      </LinkAndAnchor>,
    ]
  );
};

export default BreadCrumbs;
